import { groupBy } from 'lodash'
import * as React from 'react'
import { formatCurrency } from 'utils'

import AuthContext, { IAuthContext } from 'context/AuthContext'

import { IInvoice } from 'interfaces/IInvoice'

class Statistics extends React.Component<{
  company: IAuthContext['company']
  invoices: IAuthContext['invoices']
}> {
  public sum = (invoices: IInvoice[]) =>
    invoices.reduce(
      (sum, invoice) =>
        invoice.items ? invoice.items.reduce((s, l) => s + l.sum, sum) : sum,
      0
    )

  public moms = (invoices: IInvoice[]) =>
    invoices.reduce(
      (sum, invoice) =>
        invoice.items
          ? invoice.items.reduce(
              (s, l) => s + Math.round(l.sum * (l.moms / 100)),
              sum
            )
          : sum,
      0
    )

  public render() {
    if (!this.props.company || !this.props.invoices) {
      return null
    }

    const invoices = Object.keys(this.props.invoices).map(
      key => this.props.invoices[key]
    )

    const grouped = groupBy(invoices, (invoice: IInvoice) =>
      invoice.date.substr(0, 4)
    )

    const sum = {}
    const moms = {}
    const total = {}

    Object.keys(grouped).forEach(year => {
      sum[year] = this.sum(grouped[year])
      moms[year] = this.moms(grouped[year])
      total[year] = sum[year] + moms[year]
    })

    return (
      <table>
        <thead>
          <tr>
            <th>År</th>
            <th>Fakturor</th>
            <th>Summa</th>
            <th>Moms</th>
            <th>Totalt</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(grouped).map(year => (
            <tr key={year}>
              <td>{year}</td>
              <td>{grouped[year].length}</td>
              <td style={{ textAlign: 'right' }}>
                {formatCurrency(sum[year])}
              </td>
              <td style={{ textAlign: 'right' }}>
                {formatCurrency(moms[year])}
              </td>
              <td style={{ textAlign: 'right' }}>
                {formatCurrency(total[year])}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={2} />
            <td style={{ textAlign: 'right' }}>
              {formatCurrency(
                Object.keys(sum)
                  .map(year => sum[year])
                  .reduce((prev, s) => prev + s, 0)
              )}
            </td>
            <td style={{ textAlign: 'right' }}>
              {formatCurrency(
                Object.keys(moms)
                  .map(year => moms[year])
                  .reduce((prev, s) => prev + s, 0)
              )}
            </td>
            <td style={{ textAlign: 'right' }}>
              {formatCurrency(
                Object.keys(total)
                  .map(year => total[year])
                  .reduce((prev, s) => prev + s, 0)
              )}
            </td>
          </tr>
        </tfoot>
      </table>
    )
  }
}

export default () => (
  <AuthContext.Consumer>
    {({ invoices, company }) => (
      <Statistics invoices={invoices} company={company} />
    )}
  </AuthContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/components/Statistics/Statistics.tsx